module.exports = __webpack_public_path__ + "static/media/edly-by-arbisoft.5e46b11f.png";